import axios from "axios";
import {actionTypes} from "@/commons/constants";

export default {
	async [actionTypes.FLOWBEE.BUSCAR_CONFIGURACAO](context, header) {
		const { data } = await axios.get('/flowbee/api/public/configuracoes', {
			headers: header,
		})
		return data
	},
}
